import { useMutation } from "@tanstack/react-query";
import { FileInput } from "@mantine/core";
import IconUpload from "@tabler/icons-react/dist/esm/icons/IconUpload.mjs";
import axios from "../../../../services/axios/config";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { updateRelatedDocuments } from "../../../../redux/features/flagDetails/flagDetailsSlice";

const MAX_SIZE_MB = 10;
const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024;

export function FileUploadHandler({ id, refetch }) {
  const dispatch = useDispatch();

  const uploadMutation = useMutation({
    mutationFn: async (file) => {
      if (file.size > MAX_SIZE_BYTES) {
        throw new Error(`File size should be less than ${MAX_SIZE_MB}MB`);
      }

      const fd = new FormData();
      fd.append("file", file);

      const { data } = await axios.post(`flag/file/upload?flagId=${id}`, fd);
      return data;
    },
    onSuccess: (data) => {
      dispatch(updateRelatedDocuments(data));
      toast.success("File uploaded successfully");
    },
    onError: (err) => {
      toast.error(
        err?.message.includes("File size")
          ? err.message
          : err?.response?.data?.message ||
              "Something happened. Try again later.",
      );
    },
  });

  return (
    <FileInput
      placeholder="Click to select a file"
      leftSection={<IconUpload size={16} />}
      disabled={uploadMutation.isPending}
      onChange={(file) => file && uploadMutation.mutate(file)}
      error={
        uploadMutation.isError && !uploadMutation.isPending ? " " : undefined
      }
    />
  );
}
